// web/src/stores/commandPaletteStore.ts
// Global open/close state for the centered Cmd+K command palette modal.
//
// Distinct from the in-chat slash palette in AgentsPage — this is the
// global discovery surface, openable from anywhere via ⌘K / Ctrl+K
// or the TopBar button.
import { create } from "zustand";
export const useCommandPaletteStore = create((set) => ({
    open: false,
    onSelect: null,
    pendingChatPrompt: null,
    openPalette: (onSelect) => set({ open: true, onSelect: onSelect ?? null }),
    closePalette: () => set({ open: false }),
    setPendingChatPrompt: (prompt) => set({ pendingChatPrompt: prompt }),
    consumePendingChatPrompt: () => set({ pendingChatPrompt: null }),
}));
